"use client"

import React, { useEffect, useRef } from "react"
import "locomotive-scroll/dist/locomotive-scroll.css"

type SmoothScrollProps = {
  children: React.ReactNode
}

export function SmoothScroll({ children }: SmoothScrollProps) {
  useEffect(() => {
    let locomotiveScroll: any;

    (async () => {
      const LocomotiveScroll = (await import("locomotive-scroll")).default
      locomotiveScroll = new LocomotiveScroll({
        lenisOptions: {
          imageGrayscale: false, // disable grayscale effect
        }
      })
    })()

    return () => {
      if (locomotiveScroll) {
        locomotiveScroll.destroy()
      }
    }
  }, [])

  return <>{children}</>
}


